import React, {
	useEffect,
	useState
} from 'react';

import {
	Loader,
	LoadingView
} from '../../components/common/loader';

import {
	DeliverSuccessfull,
	DeliveryDoneByAnotherDriver,
	DeliveryErrorMessages,
	SuccessMessage,
} from '../../components/common/AllConfirmationMessages';

import { PatientDetails, VideoCallButton } from '../../components/common/patientDetails';
import PatientHandoverSheet from '../../components/common/patientHandoverSheet';

import {
	apiKey,
	deliveryDriverDeliveredDispense
} from '../../networking/urlEndPoints';

import {
	DispenseRxData,
	// GenrateRxNumberDataPDF,
	// InvestageRxPDF,
	// ReturnedPatches
} from '../../components/common/dispenseRxData';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';

import {
	SearchPatientListDeliveredByAnotherDriverAblyHelper
} from '../../utils/helper/ablyDeliveredDispenseByOthers';

import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import { fetchPatientDeliveryRx } from '../../services/apis/dispense/patientDeliveryRx';

import { useCustomStates } from '../../hooks/useCustomStates';
import { removePatientById } from '../../services/slices/dispense/patientPendingList';

import { useAuthSelector } from '../../services/selectors/authSelector';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';
// import { UploadTripilicatesPatientSigns } from '../../components/common/uploadTripilicatesPatientSigns';
// import { NewRxesConsultationDropdown } from '../../components/common/deliveryConsultationDropdown';

import { flexiNotificationRxNumbers, getFlexiDeliveryPatientIds, onhandleConfirmDelivery } from '../../utils/helper/deliveriesHelper';
import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';
import { FlexiRxStatusWarningModal } from '../../components/common/rxStatusWarningModal';


import SearchBox from '../../components/common/searchBox';
import PageNotFound from '../notFound/pageNotFound';

import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';
import * as Hooks from '../../hooks';
import * as routeName from '../../routes/routeName';
import { refreshCurrentLocation } from '../../utils/helper/helper';
import { isRxFullyDelivered } from '../../utils/helper/deliveredRxDisplay';

import avatar from '../../assets/images/userimg.png';

const DeliveryStatusBadge = ({ status }) => {
	const normalizedStatus = String(status || '').trim().toLowerCase();
	const statusDetails = {
		delivered: { label: 'Delivered', className: 'border-emerald-200 bg-emerald-50 text-emerald-700' },
		pending: { label: 'Pending', className: 'border-amber-200 bg-amber-50 text-amber-700' },
		missed: { label: 'Missed today', className: 'border-red-200 bg-red-50 text-red-700' },
		today_missed: { label: 'Missed today', className: 'border-red-200 bg-red-50 text-red-700' },
		final_missed: { label: 'Final missed', className: 'border-red-200 bg-red-50 text-red-700' },
	}[normalizedStatus] || {
		label: String(status || '').replace(/_/g, ' '),
		className: 'border-slate-200 bg-slate-50 text-slate-700',
	};

	return (
		<span
			title={`Delivery status: ${statusDetails.label}`}
			className={`inline-flex min-h-7 shrink-0 items-center justify-center gap-0.5 rounded-md border px-2 text-[11px] font-semibold whitespace-nowrap ${statusDetails.className}`}
		>
			<svg className="h-2.5 w-2.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
				{normalizedStatus === 'delivered' ? <path d="m5 12 4 4L19 6" /> : <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>}
			</svg>
			{statusDetails.label}
		</span>
	);
};

const SearchPatientList = () => {

	const dispatch = Hooks.useCustomDispatch()
	const navigate = Hooks.useCustomNavigate()
	const location = Hooks.useCustomLocation()

	const patientId = new URLSearchParams(location.search).get('id')
	const patient_Id = Number(patientId)

	const { flexiMarkedNotificationsResponse } = useSuperVisorSelector()

	const { confirmDeliveryResponse,
		patientDeliveryRxListResponse,
		validateReturnedPatchesResponse,
		pharmacist_assistant_status } = useAllSelector();

	const { pharmacyInspectionMode,
		selectedPharmacistID,
		pharmacyId,
		driverID } = useAuthSelector()

	const patientsData = patientDeliveryRxListResponse?.data?.data

	const { comment,
		setComment,

		cordinate,
		setCordinate,

		patientSignature,
		setPatientSignature,

		pharmacistSignature,
		setPharmacistSignature,

		showErrorToast,
		setShowErrorToast,

		setLoading,

		showSuccessToast,
		setShowSuccessToast,

		showComment,
		setShowComment,

		showPatientSignature,
		setShowPatientSignature,

		showPharmacistSignature,
		setShowPharmacistSignature,

		showData,
		setShowData,

		isRefused,
		setIsRefused,

		signatureErrors,
		setSignatureErrors,

		covid19,
		setCovid19,

		isTransferRequest,
		setIsTransferRequest,

		consultation,
		setConsultation,

		newRxCounsellingValues,
		setNewRxCounsellingValues,

		isPatientVerified,
		setIsPatientVerified,

		selectedDoses,
		setSelectedDoses,

		unconsumedDoseEntries,
		setUnconsumedDoseEntries,

		unconsumedDoseErrors,
		setUnconsumedDoseErrors,

		delveryDoneByAnotherDriver,
		setDeliveryDoneByAnotherDriver

	} = useCustomStates()

	const [flexiProofImages, setFlexiProofImages] = useState({})
	const [copayPaymentOptions, setCopayPaymentOptions] = useState({})

	const [showToast, setShowToast] = useState({ successToast: '' })
	const [selectedImage, setSelectedImage] = useState(patientsData?.profile_image || avatar)

	const [showFlexiConfirmation, setShowFlexiConfirmation] = useState(false)
	const [flexiRxNumbers, setFlexiRxNumbers] = useState([])
	const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
	const [deliveryCompletedElsewhere, setDeliveryCompletedElsewhere] = useState(false)

	useEffect(() => {
		if (patientDeliveryRxListResponse?.loading) {
			setShowData(false)
			setNewRxCounsellingValues([])
			setShowPharmacistSignature(false)
			setShowPatientSignature(false)
			setShowComment(false)
			setComment('')
			setPatientSignature([null])
			setPharmacistSignature(null)
			setIsPatientVerified(false)
			dispatch(RemoveAllPatchesId())
			setConsultation(null)
			setSelectedDoses({})
			setUnconsumedDoseEntries({})
			setUnconsumedDoseErrors({})
		}
	}, [patientDeliveryRxListResponse])

	useEffect(() => {
		const params = {
			id: patient_Id,
			pharmacy_id: pharmacyId
		}
		if (patientId) {
			setLoading(true)
			dispatch(fetchPatientDeliveryRx(params))
		}
		return () => { }
	}, [patient_Id])

	const refreshPatientDetails = () => {
		if (!patient_Id || !pharmacyId || patientDeliveryRxListResponse?.loading) return
		setLoading(true)
		dispatch(fetchPatientDeliveryRx({ id: patient_Id, pharmacy_id: pharmacyId }))
	}

	useEffect(() => {
		setDeliveryCompletedElsewhere(false)
	}, [patient_Id])

	useEffect(() => {
		if (!patientDeliveryRxListResponse?.loading && patientsData?.id) {
			refreshCurrentLocation(setCordinate)
		}
	}, [patientDeliveryRxListResponse?.loading, patientsData?.id, setCordinate])

	useEffect(() => {
		if (!patientDeliveryRxListResponse?.loading && patientsData?.delivery_status === 'delivered') {
			setDeliveryCompletedElsewhere(false)
		}
	}, [patientDeliveryRxListResponse?.loading, patientsData?.delivery_status])

	const handleDeliveryCompletedElsewhere = () => {
		setDeliveryCompletedElsewhere(true)
		setShowData(false)
		setShowComment(false)
		setComment('')
		setConsultation(null)
		setPatientSignature([null])
		setPharmacistSignature(null)
		setIsPatientVerified(false)
		setSelectedDoses({})
		setSelectedDeliverRxIds([])
		setUnconsumedDoseEntries({})
		setUnconsumedDoseErrors({})
		dispatch(fetchPatientDeliveryRx({
			id: patient_Id,
			pharmacy_id: pharmacyId
		}))
	}



	const allPatientsRxData = (patientsData?.rx_data ||
		patientsData?.patients_win_rx_data_delivered ||
		patientsData?.patients_win_rx_data ||
		patientsData?.patients_win_rx_data_today_missed ||
		patientsData?.patients_win_rx_data_final_missed);

	// useEffect(() => {
	// 	if (allPatientsRxData?.length) {
	// 		setSelectedDeliverRxIds(allPatientsRxData.map((r) => r.id).filter(Boolean))
	// 	} else {
	// 		setSelectedDeliverRxIds([])
	// 	}
	// }, [patientsData?.id, allPatientsRxData?.length])

	const handleConfirmDelivery = (patient_id) => {
		if (patientsData?.route_access?.allowed === false) {
			setShowErrorToast(true)
			return
		}
		setShowFlexiConfirmation(false);
		setFlexiRxNumbers([]);
		// Pass merged RX as patients_win_rx_data so helper uses it for validation and payload
		const patientDataForHelper = { ...patient_id, patients_win_rx_data: allPatientsRxData };
		onhandleConfirmDelivery(
			patientDataForHelper,
			0,
			pharmacyId,
			selectedPharmacistID,
			patientSignature,
			pharmacistSignature,
			cordinate,
			comment,
			dispatch,
			setLoading,
			() => { },
			setShowErrorToast,
			setShowSuccessToast,
			pharmacyInspectionMode,
			isRefused,
			covid19,
			'patient_search_list',
			setIsRefused,
			setSignatureErrors,
			validateReturnedPatchesResponse,
			isTransferRequest,
			setIsTransferRequest,
			pharmacist_assistant_status,
			consultation,
			newRxCounsellingValues,
			selectedDoses,
			flexiProofImages,
			copayPaymentOptions,
			{ patientId: patientId, type: 'patient_search_list' },
			isPatientVerified,
			selectedDeliverRxIds,
			unconsumedDoseEntries,
			setUnconsumedDoseErrors
		);
	}

	useEffect(() => {
		const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse, allPatientsRxData, patient_Id)
		if (matchedFlexiData && matchedFlexiData.length > 0) {
			setShowFlexiConfirmation(true);
		} else {
			setShowFlexiConfirmation(false);
		}
		return () => { }
	}, [patient_Id, allPatientsRxData, flexiMarkedNotificationsResponse])


	// const proceedWithDelivery = (patient_id) => {
	// 	const matchedFlexiData = flexiNotificationRxNumbers(flexiMarkedNotificationsResponse, allPatientsRxData, patient_id.id)
	// 	if (matchedFlexiData && matchedFlexiData.length > 0) {
	// 		setFlexiRxNumbers(matchedFlexiData);
	// 		setShowFlexiConfirmation(true);
	// 		return;
	// 	} else {
	// 		setShowFlexiConfirmation(false)
	// 		setFlexiRxNumbers([])
	// 		handleConfirmDelivery(patient_id)
	// 	}
	// }

	useEffect(() => {
		setSelectedImage(patientsData?.profile_image || avatar)
	}, [patientsData])

	// Completed RXs remain visible as history but are not outstanding work.
	const outstandingRxData = (allPatientsRxData || []).filter((rx) => !isRxFullyDelivered(rx))
	const totalCount = outstandingRxData.length || allPatientsRxData?.length || 0
	const routeAccessBlocked = patientsData?.route_access?.allowed === false
	const showRouteBlockedCard = routeAccessBlocked && patientsData?.delivery_status !== 'delivered'
	const isDeliveryLocked = deliveryCompletedElsewhere || patientsData?.delivery_status === 'delivered'
	const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
		pharmacyId,
		enabled: Boolean(
			pharmacyId &&
			patientsData?.id &&
			!patientDeliveryRxListResponse?.loading &&
			!routeAccessBlocked &&
			!isDeliveryLocked &&
			patientsData?.delivery_status !== ''
		),
		refreshKey: `patient-search:${patientId}:${patientsData?.delivery_status || ''}`,
	})
	const appointmentDelivery = !routeAccessBlocked && !isDeliveryLocked ? getMatchedAppointmentDelivery(patientsData) : null

	return (
		<>
			{pharmacyId && patientId ? <>
				<div className="app-wrapper flex justify-center">

					<div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
						<div className="relative p-4" >
							<Common.TopBar />

							<div className="flex gap-3 mb-3">
								<SearchBox pharmacyId={pharmacyId} onRefresh={refreshPatientDetails} isRefreshing={patientDeliveryRxListResponse?.loading} />
							</div>

							<div className="routes-list">

								{(patientDeliveryRxListResponse?.loading) ?

									<div className='h-96 flex items-center justify-center'>
										<LoadingView />
									</div> :

									patientDeliveryRxListResponse?.error !== null ?

										<div className='flex items-center justify-center pb-4 mb-4 h-96'>
											<ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
										</div> :

										!patientsData ? null :
											<>
												<div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3 mt-2">
													{showRouteBlockedCard ? <Common.RouteAccessBlockedNotice data={patientsData} pharmacyId={pharmacyId} enableNotifyAssignedUser /> : null}
													<PatientDetails
														data={patientsData}
														totalRxData={totalCount}
														index={0}
														patientImg={patientsData?.profile_image}
														profileImageInputId="selectProfileImage"
														alwaysShowChildren
														headerRight={
															patientsData?.delivery_status
																? <DeliveryStatusBadge status={patientsData.delivery_status} />
																: null
															}
															headerAction={<PatientHandoverSheet patient={patientsData} eligible={!isDeliveryLocked && !showRouteBlockedCard} />}
														>
														<>

															<DispenseRxData
																rxData={patientsData?.rx_data || patientsData?.patients_win_rx_data_delivered || patientsData?.patients_win_rx_data
																	|| patientsData?.patients_win_rx_data_today_missed || patientsData?.patients_win_rx_data_final_missed}
																signatureErrors={signatureErrors}
																type="new_rx"
																newRxCounsellingValues={newRxCounsellingValues}
																setNewRxCounsellingValues={setNewRxCounsellingValues}
																patientData={patientsData}
																selectedDoses={selectedDoses}
																setSelectedDoses={setSelectedDoses}
																flexiProofImages={flexiProofImages}
																setFlexiProofImages={setFlexiProofImages}
																copayPaymentOptions={copayPaymentOptions}
																setCopayPaymentOptions={setCopayPaymentOptions}
																selectedDeliverRxIds={selectedDeliverRxIds}
																setSelectedDeliverRxIds={setSelectedDeliverRxIds}
																unconsumedDoseEntries={unconsumedDoseEntries}
																setUnconsumedDoseEntries={setUnconsumedDoseEntries}
																unconsumedDoseErrors={unconsumedDoseErrors}
																setUnconsumedDoseErrors={setUnconsumedDoseErrors}
																isActiveDeliverRxCard={true}
																deliverRxSelectionEnabled={!isDeliveryLocked}
															/>

															{showData && !isDeliveryLocked && patientsData?.delivery_status !== '' &&
																<React.Fragment>
																	<Common.Comment showComment={showComment}
																		setShowComment={setShowComment}
																		setComment={setComment} comment={comment} />

																	<Common.DeliveryConsultationDropdown consultation={consultation}
																		setConsultation={setConsultation} />

																	<Common.PatientSignature patientSignature={patientSignature}
																		setPatientSignature={setPatientSignature}
																		showPatientSignature={showPatientSignature}
																		setShowPatientSignature={setShowPatientSignature}
																		setIsRefused={setIsRefused}
																		isRefused={isRefused}
																		isPatientVerified={isPatientVerified}
																		setIsPatientVerified={setIsPatientVerified}
																		signatureErrors={signatureErrors}
																		setSignatureErrors={setSignatureErrors}
																		covid19={covid19}
																		setCovid19={setCovid19}
																		rxData={(patientsData?.rx_data || patientsData?.patients_win_rx_data_delivered || patientsData?.patients_win_rx_data || patientsData?.patients_win_rx_data_today_missed || patientsData?.patients_win_rx_data_final_missed)}
																	/>

																	{pharmacist_assistant_status === 1 ? null :
																		<Common.PharmacistSignature
																			pharmacistSignature={pharmacistSignature}
																			setPharmacistSignature={setPharmacistSignature}
																			showPharmacistSignature={showPharmacistSignature}
																			setShowPharmacistSignature={setShowPharmacistSignature}
																			signatureErrors={signatureErrors}
																			setSignatureErrors={setSignatureErrors}
																		/>}


																</React.Fragment>
															}

															{!isDeliveryLocked && patientsData?.delivery_status !== '' &&
																(() => {
																	const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
																	return (
																		<div className="flex items-center gap-2">
																			<VideoCallButton
																				data={patientsData}
																				variant="cta"
																				disabled={noRxSelected || routeAccessBlocked}
																				label="Video call"
																			/>
																			{showData ?
																				

																					showFlexiConfirmation ?
																						<button className="px-4 flex-1 py-2 bg-[#10b981] text-white rounded-md"
																							onClick={() => {
																								window.location.reload();
																							}}
																						>
																							Reload
																						</button>
																						:
																						<button
																							className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || routeAccessBlocked || confirmDeliveryResponse?.loading) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																							disabled={noRxSelected || routeAccessBlocked || confirmDeliveryResponse?.loading}
																							onClick={() => {
																								if (noRxSelected || routeAccessBlocked || confirmDeliveryResponse?.loading) return;
																								handleConfirmDelivery(patientsData);
																							}}>
																							{confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loader /></p> : 'Continue'}
																						</button>
																				:
																				<button
																					className={`px-4 flex-1 py-2 rounded-md ${(noRxSelected || routeAccessBlocked) ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
																					disabled={noRxSelected || routeAccessBlocked}
																					onClick={() => {
																						if (noRxSelected || routeAccessBlocked) return;
																						setShowData(true);
																						setTimeout(() => {
																							const windowHeight = window.innerHeight;
																							const scrollAmount = windowHeight / 2;
																							window.scrollBy({ top: scrollAmount, behavior: "smooth" });
																						}, 100);
																					}}
																				>
																					Deliver
																				</button>}
																		</div>
																	);
																})()}
														</>
													</PatientDetails>
													{appointmentDelivery ? (
														<DriverAppointmentCallPanel
															patient={patientsData}
															appointmentDelivery={appointmentDelivery}
														/>
													) : null}
												</div>
											</>
								}
							</div>
						</div>

						{showErrorToast && (
							<DeliveryErrorMessages
								setShowErrorToast={setShowErrorToast}
								message={confirmDeliveryResponse?.userFacingErrorMessage}
								onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
							/>
						)}
						{showSuccessToast && <DeliverSuccessfull setShowSuccessToast={setShowSuccessToast} />}
						{delveryDoneByAnotherDriver && <DeliveryDoneByAnotherDriver setMissedDeliveryErrorToast={setDeliveryDoneByAnotherDriver} message={delveryDoneByAnotherDriver} />}

					</div>
				</div>

				{showToast.successToast && <SuccessMessage message={'Profile Updated Successfully.'} setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />}

				<SearchPatientListDeliveredByAnotherDriverAblyHelper
					apiKey={apiKey}
					deliveryDriverDeliveredDispense={deliveryDriverDeliveredDispense}
					pharmacyId={pharmacyId}
					driverID={driverID}
					dispatch={dispatch}
					setCordinate={setCordinate}
					setLoading={setLoading}
					patientId={patientId}
					removePatientById={removePatientById}
					setDeliveryDoneByAnotherDriver={setDeliveryDoneByAnotherDriver}
					onDeliveredElsewhere={handleDeliveryCompletedElsewhere}
				/>

				{/* <FlexiRxStatusWarningModal
					rxNumbers={flexiRxNumbers}
					showModal={showFlexiConfirmation}
					setShowModal={setShowFlexiConfirmation}
				// onConfirm={() => handleConfirmDelivery(patientsData)}
				// onCancel={() => setShowFlexiConfirmation(false)}
				/> */}

			</> : <PageNotFound />}
		</>
	)
}

export default SearchPatientList
